module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("\n        Add Multiple Vehicle/s\n    ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("New Vehicles")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "newVehicle",
    model: {
      value: (_vm.newVehicleValid),
      callback: function($$v) {
        _vm.newVehicleValid = $$v
      },
      expression: "newVehicleValid"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.customerList,
      "loading": _vm.gettingCustomers,
      "label": "Select a Customer",
      "item-text": "name",
      "item-value": "key",
      "required": "",
      "rules": [function (v) { return !!v || 'Customer is required'; }],
      "disabled": _vm.customerFixed
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Quantity",
      "rules": [function (v) { return !!v || 'Quantity is required'; }, function (v) { return v > 0 || 'Quantity must be greater than 0'; }],
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Make",
      "items": _vm.vehicleMakes,
      "item-text": "name",
      "item-value": "key",
      "clearable": ""
    },
    model: {
      value: (_vm.makeSelect),
      callback: function($$v) {
        _vm.makeSelect = $$v
      },
      expression: "makeSelect"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Model",
      "items": _vm.modelList,
      "item-text": "name",
      "item-value": "key",
      "loading": _vm.gettingModels,
      "clearable": ""
    },
    model: {
      value: (_vm.modelSelect),
      callback: function($$v) {
        _vm.modelSelect = $$v
      },
      expression: "modelSelect"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Year",
      "type": "number",
      "mask": "####"
    },
    model: {
      value: (_vm.Year),
      callback: function($$v) {
        _vm.Year = $$v
      },
      expression: "Year"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Site",
      "items": _vm.sites,
      "item-text": "name",
      "rules": [function (v) { return !!v || 'Site is required'; }],
      "item-value": "key",
      "append-outer-icon": "mdi-plus"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.siteDialog = true
      }
    },
    model: {
      value: (_vm.Site),
      callback: function($$v) {
        _vm.Site = $$v
      },
      expression: "Site"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.siteDialog),
      callback: function($$v) {
        _vm.siteDialog = $$v
      },
      expression: "siteDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.siteDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Sites")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.siteDialog = false
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-layout', [(_vm.siteDialog) ? _c('sites-view') : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": "",
      "disabled": !_vm.newVehicleValid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f60958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/MultiVehicleDialog.vue
// module id = 733
// module chunks = 1